<template>
    <kgr-form-scaffold
        :pending="pending"
        @primaryBtnClicked="addMember"
        @backBtnClicked="redirectToOverview"
    >
        <kgr-member-create-form
            :member="member"
            :error="error"
            @enter="addMember"
        />
    </kgr-form-scaffold>
</template>

<script>
import Error from '../../js/model/Error';
import FormScaffold from '../../components/common/form/FormScaffold';
import Member from '../../js/dto/Member';
import MemberCreateForm from '../../components/members/MemberCreateForm';
import MemberRepository from '../../js/repository/MemberRepository';

export default {
    components: {
        'kgr-member-create-form': MemberCreateForm,
        'kgr-form-scaffold': FormScaffold,
    },
    props: {
        overviewUrl: {
            type: String,
            required: true,
        },
        clubId: {
            type: Number,
            required: true,
        },
    },
    data() {
        return {
            pending: false,
            member: new Member(),
            error: new Error(),
        };
    },
    methods: {
        redirectToOverview() {
            window.location = this.overviewUrl;
        },
        addMember() {
            if (this.pending) {
                return;
            }

            this.pending = true;

            MemberRepository.create(this.member, this.clubId)
                .then((id) => {
                    this.$notify.success('Mitglied erfolgreich hinzugefügt', {}, { saveInSession: true });
                    window.location = `/backend/clubs/members/${id}/edit/basicData`;
                })
                .catch((error) => {
                    this.error = error;
                    this.$notify.error('saveChanges.error');
                    this.pending = false;
                });
        },
    },
};
</script>

<style scoped lang="scss" rel="stylesheet/scss"></style>
